module.exports = __webpack_public_path__ + "static/media/dc.9f34c55b.png";